import Toast from './Toast';

export default function ToastStack({ toasts, onRemove }) {
  return (
    <div className="toast-stack">
      {toasts.map(t => (
        <Toast key={t.id} msg={t.msg} type={t.type} onDone={() => onRemove(t.id)} />
      ))}
    </div>
  );
}
